export const translations = {
  bn: {
    app_name: "শিক্ষা বিডি",
    app_subtitle: "বাংলাদেশ শিক্ষা মন্ত্রণালয় শিক্ষক ট্যাবলেট প্ল্যাটফর্ম",
    // Roles
    role_teacher: "শিক্ষক",
    role_principal: "প্রধান শিক্ষক",
    role_district: "জেলা প্রশাসক",
    role_moe: "শিক্ষা মন্ত্রণালয়",
    // Navigation
    nav_home: "হোম",
    nav_attendance: "হাজিরা",
    nav_meals: "খাবার",
    nav_health: "স্বাস্থ্য",
    nav_more: "আরও",
    nav_governance: "প্রশাসন",
    nav_schools: "বিদ্যালয়সমূহ",
    nav_students: "শিক্ষার্থী",
    nav_teachers: "শিক্ষকবৃন্দ",
    nav_incidents: "ঘটনা",
    nav_lesson_plans: "পাঠ পরিকল্পনা",
    nav_integrations: "সরকারি সংযোগ",
    nav_sdg4: "SDG4 সূচক",
    nav_alerts: "সতর্কতা",
    // Common
    save: "সংরক্ষণ করুন",
    cancel: "বাতিল করুন",
    submit: "জমা দিন",
    loading: "লোড হচ্ছে...",
    search: "অনুসন্ধান করুন",
    filter: "ছাঁকুন",
    export_pdf: "PDF রপ্তানি",
    view_all: "সব দেখুন",
    total: "মোট",
    date: "তারিখ",
    status: "অবস্থা",
    actions: "কাজ",
    // Attendance
    att_title: "হাজিরা",
    att_mark: "হাজিরা নিন",
    att_present: "উপস্থিত",
    att_absent: "অনুপস্থিত",
    att_late: "দেরিতে",
    att_excused: "অনুমতিসহ",
    att_mark_all: "সবাইকে উপস্থিত চিহ্নিত করুন",
    att_submit: "হাজিরা জমা দিন",
    att_saved: "হাজিরা সংরক্ষিত হয়েছে",
    att_report: "হাজিরার প্রতিবেদন",
    att_rate: "উপস্থিতির হার",
    att_students: "শিক্ষার্থী",
    att_select_class: "শ্রেণি নির্বাচন করুন",
    att_select_section: "শাখা নির্বাচন করুন",
    // Meals
    meal_title: "খাবার",
    meal_record: "আজকের তথ্য দিন",
    meal_beneficiary: "উপকারভোগী সংখ্যা",
    meal_absent: "অনুপস্থিত সংখ্যা",
    meal_served: "পরিবেশন করা হয়েছে",
    meal_not_served: "পরিবেশন হয়নি",
    meal_partial: "আংশিক",
    meal_photo: "খাবারের ছবি তুলুন",
    meal_submit: "খাবারের তথ্য জমা দিন",
    meal_saved: "খাবারের তথ্য সংরক্ষিত হয়েছে",
    meal_anomaly: "অসঙ্গতি সতর্কতা",
    meal_supplier: "সরবরাহকারী",
    meal_analytics: "বিশ্লেষণ",
    // Health
    health_title: "স্বাস্থ্য",
    health_my: "আমার স্বাস্থ্য",
    health_phr: "স্বাস্থ্য রেকর্ড",
    health_blood: "রক্তের গ্রুপ",
    health_allergies: "অ্যালার্জি",
    health_conditions: "দীর্ঘমেয়াদি রোগ",
    health_medications: "বর্তমান ওষুধ",
    health_telemedicine: "অনলাইন ডাক্তার",
    health_book: "অ্যাপয়েন্টমেন্ট নিন",
    health_mental: "মানসিক সুস্বাস্থ্য",
    health_womens: "মহিলাদের স্বাস্থ্য",
    health_bp: "রক্তচাপ",
    health_glucose: "রক্তে শর্করা",
    health_mood: "মেজাজ ট্র্যাকার",
    health_privacy: "আপনার স্বাস্থ্য তথ্য সম্পূর্ণ ব্যক্তিগত। কোনো সরকারি কর্মকর্তা বা প্রধান শিক্ষক এই তথ্য দেখতে পাবেন না।",
    health_emergency: "জরুরি সাহায্য",
    health_call_999: "৯৯৯ ডায়াল করুন",
    // Governance
    gov_title: "প্রশাসন ড্যাশবোর্ড",
    gov_kpi: "মূল কর্মসূচি সূচক",
    gov_schools: "বিদ্যালয়সমূহ",
    gov_welfare: "কল্যাণ সতর্কতা",
    gov_anomaly: "অসঙ্গতি",
    gov_sdg4: "SDG4 ট্র্যাকার",
    // Incidents
    inc_title: "ঘটনা রিপোর্ট",
    inc_new: "নতুন ঘটনা রিপোর্ট করুন",
    inc_type: "ঘটনার ধরন",
    inc_severity: "গুরুত্বের মাত্রা",
    inc_description: "বিবরণ",
    inc_anonymous: "পরিচয় গোপন রেখে রিপোর্ট করুন",
    inc_submitted: "ঘটনা রিপোর্ট সংরক্ষিত হয়েছে",
    // Lesson
    lesson_title: "পাঠ পরিকল্পনা",
    lesson_generate: "AI দিয়ে খসড়া তৈরি করুন",
    lesson_generating: "AI তৈরি করছে...",
    lesson_grade: "শ্রেণি",
    lesson_subject: "বিষয়",
    lesson_chapter: "অধ্যায়",
    lesson_objective: "শিখন উদ্দেশ্য",
    lesson_save: "আমার পরিকল্পনায় সংরক্ষণ",
    lesson_ai_label: "AI সহায়তায় তৈরি — শিক্ষক পর্যালোচনা করুন",
    lesson_preview: "পাঠ পরিকল্পনা (প্রিভিউ)",
    // LMS
    nav_lms: "CPD ও LMS",
    lms_courses: "সকল কোর্স",
    lms_my: "আমার কোর্স",
    lms_leaderboard: "লিডারবোর্ড",
    lms_enrol: "ভর্তি হন",
    lms_mandatory: "বাধ্যতামূলক",
    lms_certificate: "সনদপত্র",
    // Grades
    nav_grades: "ফলাফল",
    grades_entry: "নম্বর প্রদান",
    grades_analytics: "ফলাফল বিশ্লেষণ",
    grades_save: "নম্বর সংরক্ষণ করুন",
    // Communication
    nav_communication: "যোগাযোগ",
    comm_circulars: "বিজ্ঞপ্তি",
    comm_messages: "বার্তা",
    comm_community: "সম্প্রদায়",
    comm_new_post: "নতুন পোস্ট",
    comm_new_circular: "নতুন বিজ্ঞপ্তি",
    // Demo
    demo_start: "ডেমো শুরু করুন",
    demo_walkthrough: "ডেমো ওয়াকথ্রু",
    // Sync
    sync_engine: "সিঙ্ক ইঞ্জিন",
    sync_online: "অনলাইন",
    sync_offline_mode: "অফলাইন মোড",
    sync_pending_items: "অপেক্ষমাণ আইটেম",
    // Greeting
    greeting_morning: "সুপ্রভাত",
    greeting_afternoon: "শুভ অপরাহ্ন",
    greeting_evening: "শুভ সন্ধ্যা",
    // Offline
    offline: "আপনি অফলাইনে আছেন",
    synced: "তথ্য সিঙ্ক হয়েছে",
    sync_pending: "সিঙ্ক অপেক্ষায়",
  },
  en: {
    app_name: "Shiksha BD",
    app_subtitle: "Bangladesh MoE Teacher Tablet Platform",
    role_teacher: "Teacher",
    role_principal: "Principal",
    role_district: "District Admin",
    role_moe: "MoE National",
    nav_home: "Home",
    nav_attendance: "Attendance",
    nav_meals: "Meals",
    nav_health: "Health",
    nav_more: "More",
    nav_governance: "Governance",
    nav_schools: "Schools",
    nav_students: "Students",
    nav_teachers: "Teachers",
    nav_incidents: "Incidents",
    nav_lesson_plans: "Lesson Plans",
    nav_integrations: "Gov. Integrations",
    nav_sdg4: "SDG4 Indicators",
    nav_alerts: "Alerts",
    save: "Save",
    cancel: "Cancel",
    submit: "Submit",
    loading: "Loading...",
    search: "Search",
    filter: "Filter",
    export_pdf: "Export PDF",
    view_all: "View All",
    total: "Total",
    date: "Date",
    status: "Status",
    actions: "Actions",
    att_title: "Attendance",
    att_mark: "Mark Attendance",
    att_present: "Present",
    att_absent: "Absent",
    att_late: "Late",
    att_excused: "Excused",
    att_mark_all: "Mark All Present",
    att_submit: "Submit Attendance",
    att_saved: "Attendance saved",
    att_report: "Attendance Report",
    att_rate: "Attendance Rate",
    att_students: "Students",
    att_select_class: "Select Grade",
    att_select_section: "Select Section",
    meal_title: "Meals",
    meal_record: "Record Today",
    meal_beneficiary: "Beneficiary Count",
    meal_absent: "Absent Count",
    meal_served: "Served",
    meal_not_served: "Not Served",
    meal_partial: "Partial",
    meal_photo: "Take meal photo",
    meal_submit: "Submit Meal Record",
    meal_saved: "Meal record saved",
    meal_anomaly: "Anomaly Alert",
    meal_supplier: "Supplier",
    meal_analytics: "Analytics",
    health_title: "Health",
    health_my: "My Health",
    health_phr: "Health Record",
    health_blood: "Blood Group",
    health_allergies: "Allergies",
    health_conditions: "Chronic Conditions",
    health_medications: "Current Medications",
    health_telemedicine: "Telemedicine",
    health_book: "Book Appointment",
    health_mental: "Mental Wellness",
    health_womens: "Women's Health",
    health_bp: "Blood Pressure",
    health_glucose: "Blood Glucose",
    health_mood: "Mood Tracker",
    health_privacy: "Your health data is completely private. No government official or principal can access this information.",
    health_emergency: "Emergency Help",
    health_call_999: "Call 999",
    gov_title: "Governance Dashboard",
    gov_kpi: "Key Performance Indicators",
    gov_schools: "Schools",
    gov_welfare: "Welfare Alerts",
    gov_anomaly: "Anomalies",
    gov_sdg4: "SDG4 Tracker",
    inc_title: "Incident Report",
    inc_new: "Report New Incident",
    inc_type: "Incident Type",
    inc_severity: "Severity",
    inc_description: "Description",
    inc_anonymous: "Report Anonymously",
    inc_submitted: "Incident report saved",
    lesson_title: "Lesson Plan",
    lesson_generate: "Generate with AI",
    lesson_generating: "AI is generating...",
    lesson_grade: "Grade",
    lesson_subject: "Subject",
    lesson_chapter: "Chapter",
    lesson_objective: "Learning Objective",
    lesson_save: "Save to My Plans",
    lesson_ai_label: "AI-assisted — please review",
    lesson_preview: "Lesson Planner (Preview)",
    nav_lms: "CPD & LMS",
    lms_courses: "All Courses",
    lms_my: "My Courses",
    lms_leaderboard: "Leaderboard",
    lms_enrol: "Enrol",
    lms_mandatory: "Mandatory",
    lms_certificate: "Certificate",
    nav_grades: "Grades",
    grades_entry: "Grade Entry",
    grades_analytics: "Grade Analytics",
    grades_save: "Save Grades",
    nav_communication: "Communication",
    comm_circulars: "Circulars",
    comm_messages: "Messages",
    comm_community: "Community",
    comm_new_post: "New Post",
    comm_new_circular: "New Circular",
    demo_start: "Start Demo",
    demo_walkthrough: "Demo Walkthrough",
    sync_engine: "Sync Engine",
    sync_online: "Online",
    sync_offline_mode: "Offline Mode",
    sync_pending_items: "Pending Items",
    greeting_morning: "Good Morning",
    greeting_afternoon: "Good Afternoon",
    greeting_evening: "Good Evening",
    offline: "You are offline",
    synced: "Data synced",
    sync_pending: "Sync pending",
  }
};
